import { Mesh, type Object3D } from "three";
import type { GLTF } from "three/examples/jsm/loaders/GLTFLoader.js";

export function instantiateModel(gltf: GLTF): Object3D {
  const instance = gltf.scene.clone();
  instance.traverse((object) => {
    if (!(object instanceof Mesh)) return;
    object.castShadow = true;
    object.receiveShadow = true;
  });
  return instance;
}
